import React, { useEffect, useState } from "react";
import { getAppRatings } from "./analytics.service";

import star from "../../Assets/star.svg"
import BorderLinear from "../../util/BorderLinear";
import StarRatings from "../../util/StarRatings";

const Ratings = ({ app }) => {

    const [appData, setAppData] = useState();
    const [summary, setSummary] = useState([]);

    useEffect(async () => {
        const res = await getAppRatings(app?.id,app?.platform);
        setAppData(res.data.data);
        setSummary(res.data.data.summary)
    }, []);

    return (
        <>
            {
                appData && <div className="d-flex d-justify-evenly">
                    <div className="d-flex d-flex-column">
                        <div className="d-flex d-flex-column mtc-20 d-align-center">
                            {appData.average !== 0 ? (<span className="font-size-50 font-bold">{Math.round(appData?.average * 10) / 10}</span>):(<span className="text-gray font-size-50 font-bold">NA</span>)}
                            <StarRatings value={appData?.average} precision={0.5}/>
                        </div>
                    </div>
                    <div style={{ flex: "0.4", color: "gray" }}>
                        <div className="p_all-10">
                            {summary.map((item, index) => (
                                <div key={index} className="d-flex pb-6">
                                    <span className="pr-6">{5 - index}</span><span><img src={star} alt="star" /></span>
                                    <span className="pt-6 pl-6 pr-6">
                                    <BorderLinear value={appData.totalRating === 0 ? 0 : (appData?.summary[4 - index]?.count / appData?.totalRating) * 100}
                                        height={15} width={252} borderRadius={5} primaryBackColor={"black"} barBackColor={"#4096EF"}
                                    /></span>
                                    <span>{appData?.totalRating === 0 ? 0 : Math.round(((appData?.summary[4 - index]?.count / appData?.totalRating) * 100) * 10) / 10}</span>
                                    <span className="font-size-12 mtc-4">%</span>
                                </div>
                            ))}
                        </div>
                    </div>   
                                     
                    <div>
                        <div className="p_all-10">
                            <div className="d-flex d-flex-column">
                                <span className="font-bold font-size-14">Total Rating</span>
                                {appData?.totalRating !== 0 ? (<span className="font-size-20 font-bold">{appData?.totalRating}</span>) : (<span className="text-gray font-size-20 font-bold">NA</span>)}                            
                            </div>
                        </div>
                        <div className="p_all-10">
                            <div className="d-flex d-flex-column">
                                <span className="font-bold font-size-14">Ratings with Reviews</span>
                                {appData?.reviewCount !== 0 ? (<span className="font-size-20 font-bold">{appData?.reviewCount}</span>) : (<span className="text-gray font-size-20 font-bold">NA</span>)} 
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default Ratings;